import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M17.783 1.466c.774 0 1.402.628 1.402 1.402v2.609c0 .774-.628 1.402-1.402 1.402h-5.12v5.02l4.467.001c1.083 0 1.97.839 2.05 1.902l.005.153v3.268a2.707 2.707 0 1 1-1.5 0v-3.268a.555.555 0 0 0-.465-.547l-.09-.008h-4.467l.001 3.823a2.708 2.708 0 0 1 1.95 2.43l.006.171a2.706 2.706 0 1 1-3.457-2.601V13.4H6.696a.555.555 0 0 0-.547.465l-.008.09v3.268a2.707 2.707 0 1 1-1.5 0v-3.268c0-1.083.839-1.97 1.901-2.049l.154-.006h4.467V6.879h-5.12a1.403 1.403 0 0 1-1.395-1.267l-.007-.135v-2.61c0-.773.628-1.401 1.402-1.401zM5.39 18.618a1.206 1.206 0 1 0 0 2.412 1.206 1.206 0 0 0 0-2.412zm6.522 0a1.206 1.206 0 1 0 0 2.412 1.206 1.206 0 0 0 0-2.412zm6.522 0a1.206 1.206 0 1 0-.001 2.412 1.206 1.206 0 0 0 0-2.412zm-.751-15.653H6.141v2.413h11.543V2.965z' />
  </svg>
);
